<template>
  <section
    class="main_section product-section ratio_85 padding-cls fixed-mp-cls pt-0"
  >
    <div ref="deliveryArea" class="no-da-selected" v-if="!isModuleEnable(CONST.MODULE_WEBSITE) && domainBasedBrand">
            {{ _T('This Website not serving order(s) these days.') }}
    </div>
    <template v-else-if="selectedDa">
      <div class="container">
        <div
          class="row custom-col-cls infinite-loader-sec"
          v-if="brandWiseStores.length"
        >
          <StoreBrandTile
            :brand="currentBrand"
            v-for="(brandStore, index) in brandWiseStores"
            :key="index"
            :store="brandStore"
          />
        </div>
        <div v-else class="no-da-selected">
          <div class="row custom-col-cls infinite-loader-sec">
            {{ _T('Sorry, No stores delivering orders here') }}
          </div>
        </div>
      </div>
    </template>
    <div class="container no-data" v-else>
      <div class="no-da-selected d-flex align-items-center">
        <div class="row custom-col-cls infinite-loader-sec">
          {{ _T('Please select where you want your order to be delivered') }}
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import StoreBrandTile from '../Collections/StoreBrandTile'

export default {
  name: 'PopularStores',
  components: { StoreBrandTile },
  watch: {
    selectedDa(val) {
      if (this.domainBasedBrand && val.length && this.brandWiseStores.length) {
        if (this.showDefaultStore) {
          this.$router.push(`stores/${this.brandWiseStores[0]['_id']}`)
        }
      }
    },
  },
  computed: {
    ...mapGetters([
      '_T',
      'selectedDa',
      'brandWiseStores',
      'domainBasedBrand',
      'currentBrand',
      'isModuleEnable',
    ]),
    showDefaultStore() {
      if (this.brandWiseStores.length == 1) {
        if (this.currentBrand && this.currentBrand.store_as_default_page) {
          return true
        }
      }
      return false
    }
  },
  data() {
    return {
      openStoreList: false,
    }
  },
  beforeMount() {
    //this.$store.dispatch('load_brand_stores')
  },
}
</script>

<style lang="scss" scoped>
@media (max-width: 575px) {
  .main_section {
    min-height: 50vh !important;
  }
}

.no-data {
  padding-bottom: calc(30px + (80 - 30) * ((100vw - 320px) / (1920 - 320)));
}
.no-da-selected {
  padding: 2rem;
  font-size: $px24;
  text-align: center;
  color: $color-primary;
  font-weight: 600;
  display: flex;
  justify-content: space-around;
}
.stores-container {
  padding: 4rem;
  .stores-header {
    font-size: 2rem;
    padding-bottom: 4rem;
    background-color: $color-primary;
  }
  .stores-body {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-gap: 2rem 1rem;
  }
}
</style>
